import { axiosInstance, TENANT_API_URL } from "..";

export const SHIFT_DOCS_URL = `${TENANT_API_URL}/staff/documents`;

export const getStaffDoc = (id?: string) =>
  axiosInstance.get(`${SHIFT_DOCS_URL}?id=${id}`);

export const createStaffDoc = (data: any) =>
  axiosInstance.post(`${SHIFT_DOCS_URL}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const updateStaffDoc = (id: string, data: any) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.put(`${SHIFT_DOCS_URL}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteStaffDoc = (id: string) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.delete(`${SHIFT_DOCS_URL}/${id}`);
};
